import React, { useState } from "react";
import {
  Modal,
  Button,
  Spinner,
} from "react-bootstrap";
import { authHeader } from "../../../_helpers/auth-header";

import axiosInstance from "../../../_helpers/axiosConfig";

export default function CloseModal(props) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Close Pending Time Slots</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to close <strong>Pending</strong> time slots?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={loading}
            onClick={() => {
              setLoading(true);

              axiosInstance
                .request({
                  headers: authHeader(),
                  method: "POST",
                  url: `${process.env.REACT_APP_API_URL}/vaccine/schedule/${props.scheduleId}/close`,
                })
                .then((response) => {
                  window.location.reload();
                })
                .catch((error) => {
                  setLoading(false);

                  alert("Something went wrong please try again.");
                });
            }}
          >
            {loading ? <Spinner size="sm" animation="border"></Spinner> : "Yes"}
          </Button>
          <Button disabled={loading} onClick={() => setShowConfirm(false)}>Cancel</Button>
        </Modal.Footer>
      </Modal>

      <button onClick={() => {
        setShowConfirm(true);
      }} type="button" className="btn btn-warning">Close Pending</button>
    </div>
  );
}
